import React, { useState, lazy, useEffect } from "react";
import { CommonHeader, MainContent, CommonContent, SpinWrapper } from "../../css/css";
import ChatLog from "../../components/chat-log/chatLog";
import AllContent from "../../components/show-type/Allcontent";
import styled, { createGlobalStyle } from "styled-components";
import CovSearch from "../../components/conversation/conSearch";
import ContactList from "../../components/conversation/contactList";
import { useUpdateEffect } from "../../hooks/useUpdateEffect";
import api from "../../apis/pc/conversation/conversation";
import OpenIcon from "../../img/open-right.png";
import CloseIcon from "../../img/close-right.png";
import HeadImg from "../../components/common/head-img/headImg";
import UserLabels from "../../components/conversation/userLabels";
import { getParameterByName } from "@/utils/utils";
import BackIcon from '@/components/common/merge-compoments/back-btn';
import { usePermission } from "../../hooks/usePermission"
import { Spin } from "antd";
import Show from "@/components/show/show";
import WxImg from "@/img/wx-img.png"
import { connect } from 'react-redux';
import { getMessageSettingsOpen } from "@/actions/messageSettingsOpen";
import { useHistory } from "react-router-dom";
import { scrollToFirstMessage } from "./conversation-utils";
const NoPermission = lazy(() => import('@/pages/no-permission/no-permission').then()) //缺省页

const mapDispatchToProps = { getMessageSettingsOpen };

const mapStateToProps = (state) => {
  const { messageSettingsOpen, enterPriseInfo } = state
  return { messageSettingsOpen: messageSettingsOpen.messageSettingsOpen, enterPriseInfo: enterPriseInfo?.enterPriseInfo }
}

const ConversationWrapper = styled.div`
  display: flex;
  background: white;
  height: calc(100vh - 130px);
`;
const LeftPart = styled.div`
  min-width: 336px;
  border-right: 1px solid #e9e9e9;
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 8px;
    height: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background: #E8EBF6;

    &:hover{
      background: #9A9EBA;
    }
    border-radius: 10px;
  }
  ::-webkit-scrollbar-track{
      background-color: #fff;
      border-radius: 2px;
  }
`;
const RightPart = styled.div`
  width: 100%;
`;
const ConversationTitle = styled.div`
  height: 76px;
  width: 100%;
  display: flex;
  border-bottom: 1px solid #e9e9e9;
  padding: 16px 24px 0 24px;
`;
const ConversationContent = styled.div`
  height: calc(100% - 76px);
  display: flex;
  overflow: hidden;
`;
const ConversationBottom = styled.div`
  height: 64px;
  width: 100%;
  background: white;
  box-shadow: 0px -2px 1px 0px rgba(0, 0, 0, 0.05);
`;

const InfoBar = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  .cv-name {
    color: #595959;
    font-weight: bold;
    font-size: 14px;
  }
  .cv-corpName {
    margin-left: 8px;
    font-size: 12px;
    color: #bfbfbf;
    font-weight: 400;
  }
  .cv-roomOwnerName{
    font-size: 12px;
  }
  .session-content {
    flex: 10;
  }
`;
const IconWrapper = styled.div`
  border-radius: 2px;
  border: 1px solid #d9d9d9;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 12px;
  width: 24px;
  height: 24px;
  &.active {
    background: #fff2ea;
  }
`;
const ShowIcon = styled.img`
  width: 10px;
  height: 10px;
  cursor: pointer;
`;
const WhiteBackground = createGlobalStyle`
  body {
    .white-background .ant-tooltip-inner {
      font-size: 14px;
      font-weight: 400;
      color: #999999;
    }
  }
`;
/**
 * @设计理念: 整个消息存档维护3个参数，无论是在联系人列表，搜索结果列表，右侧搜索都是统一的逻辑
 * @params: operateData（当前查看的员工, 联系人列表使用）
 * @params: currentSession（当前操作的会话）
 * @params: currentMessage（当前操作的消息）
 */
const ConversationNew = (props) => {
  const { enterPriseInfo, showHistoryGray } = props
  const [currentSession, setCurrentSession] = useState({}); // 当前正在操作的会话，决定了聊天记录栏显示的内容
  const [currentMessage, setCurrentMessage] = useState({}); // 当前操作的消息
  // lastMessageId配合pageType的方式有问题 使用pageNum请求分页
  const initCondition = { pageSize: 50, messageType: 1, pageType: 1, pageNum: 1 }; // messageType 1 全部 2 文件 3 图片 
  const [chatSearchCondition, setChatSearchCondition] = useState(initCondition);
  const [chatLog, setChatLog] = useState({ list: [] });
  const [isClose, setIsClose] = useState(false); // 右侧栏默认收起状态
  const [pageType, setPageType] = useState("contactList");
  const [searchCondition, setSearchCondition] = useState({});
  const [scrollType, setScrollType] = useState("bottom");
  const pathParms = props.location.pathname.split("/");
  const { hasPermission } = usePermission('查看消息存档')
  const [chatType, setChatType] = useState("1")
  const [selectFlag, setSelectFlag] = useState(true)
  const [uid, setUid] = useState('')
  const [loading, setLoading] = useState(false)
  const [isEmpty, setIsEmpty]= useState(false)

  // 这俩不满足会跳到扫码页
  const showContactList = enterPriseInfo?.corpId && enterPriseInfo?.enable && pageType === 'contactList'

  const history = useHistory()
  
  // 改变会话或者当前的消息
  const changeSessionOrMessage = (value) => {
    if (value.setType === "message") {
      setCurrentMessage(value);
      setScrollType("message");
    } else if (value.setType === "clear") {
      setCurrentSession(value);
      setChatLog({ list: [] });
      setScrollType("bottom");
    } else {
      setCurrentSession(value);
      // setIsClose(true);
      setScrollType("bottom");
    }
    setIsClose(true);
    setTimeout(() => {
      setIsClose(false);
    }, 100);
  };

  // 查找聊天记录（接口3）
  const chatSearch = () => {
    const { sessionId } = currentSession;
    let params = {
      sessionId,
      ...chatSearchCondition,
      extendUserId: searchCondition.extendUserId,
      uid: uid,
    };
    if (uid) {
      delete params.extendUserId
    } else {
      delete params.uid
    }
    if (!params.sessionId) {
      setChatLog({ list: [] });
      return;
    }
    setLoading(true);
    api.chatSearch(params).then((res) => {
      setLoading(false);
      if (res.code === 0) {
        {
          /*pageType为1表示初始，2表示下拉，3表示向上加载*/
        }
        if (chatSearchCondition.pageType === 1) {
          setChatLog(res.data);
        } else if (chatSearchCondition.pageType === 2) {
          // 老逻辑排序有问题 -倒叙展示后2-3逻辑替换
          // 不再需要倒序 上滑加载更多
          let temp = chatLog.list.concat(res.data.list)
          // let temp = res.data.list.concat(chatLog.list);
          setChatLog({ ...res.data, list: temp });
        } else if (chatSearchCondition.pageType === 3) {
          // 老逻辑排序有问题 -倒叙展示后2-3逻辑替换
          // 不再需要倒序 上滑加载更多
          let temp = res.data.list.concat(chatLog.list);
          // let temp = chatLog.list.concat(res.data.list);
          setChatLog({ ...res.data, list: temp });
        }
        setTimeout(() => {
          scrollToFirstMessage(chatSearchCondition, res.data.list);
        }, 0);
      } else {
        setChatLog({ list: [] });
      }
    });
  };

  // 点击是否展开右侧栏
  const handleOpenInfo = () => {
    setIsClose(!isClose);
  };

  // 搜索
  const handleSearch = (value) => {
    // if (value.extendUserId || value.content) {
    //   setPageType("search");
    // } else {
    //   setPageType("contactList");
    //   setCurrentMessage({ list: [] });
    // }
    setSearchCondition({
      ...value,
    });
    setSelectFlag(value.selectFlag)
  };

  useUpdateEffect(() => {
    chatSearch();
  }, [chatSearchCondition]);

  useUpdateEffect(() => {
    if (currentSession.setType === "session") {
      setChatSearchCondition(initCondition);
    }
    if (currentSession.setType === "clear") {
      setChatLog({ list: [] });
    }
  }, [currentSession]);

  useUpdateEffect(() => {
    setChatSearchCondition({
      ...initCondition,
      content: searchCondition.content,
      messageType: 1,
      messageId: currentMessage.id,
    });
  }, [currentMessage]);

  const handleClear = () => {
    setChatSearchCondition(initCondition);
  };

  const getUserList = ({ innerUser, outGroup, innerGroupList, outConnection, clieckType}) => {
    let isIframe = getParameterByName('deviceType') === 'iframe'
    // clieckType 1 外部好友 3 内部好友 2 外部群 4 内部群
    let allUser = [...innerUser, ...outGroup, ...innerGroupList, ...outConnection]
    if(allUser?.length < 1) {
      setIsEmpty(isIframe)
      return 
    }
    // tab下没数据暂无记录
    const empty = [outConnection, outGroup, innerUser, innerGroupList][+clieckType - 1]?.length === 0
    setIsEmpty(empty && isIframe)
  }

  return (
    <MainContent style={{ height: 'calc(100vh - 65px)', overflowY: 'hidden' }}>
      <WhiteBackground />
      <SpinWrapper />
      {hasPermission ? (
        <>
          <CommonHeader
            style={
              getParameterByName('deviceType') === 'iframe'
                ? {
                    width: '100%',
                    height: '50px',
                  }
                : {}
            }
          >
            <div
              className='traffic-header-title'
              style={
                getParameterByName('deviceType') === 'iframe'
                  ? {
                      height: '50px',
                    }
                  : {}
              }
            >
              <div>
                {getParameterByName('deviceType') === 'iframe' ? (
                  ''
                ) : (
                  <>
                    <BackIcon />
                    <span className='title-name'>{showHistoryGray ? '历史存档' : '会话存档'}
                      {
                        showHistoryGray ? (
                          <span className='retrieve title-mini' onClick={() => {props.onChange()}}>会话存档</span>
                        ) : null
                      }
                    </span>
                    {/* <Tooltip
                      placement="right"
                      title={conversationTip}
                      color="#fff"
                      overlayClassName="white-background"
                    >
                      <img
                        src={tooltip}
                        alt="tooltip"
                        style={{ cursor: "pointer" }}
                      />
                    </Tooltip> */}
                  </>
                )}
              </div>
              <CovSearch handleSearch={handleSearch} chatType={chatType} />
            </div>
          </CommonHeader>
          <Spin
            spinning={loading}
            wrapperClassName='spin-center-wrapper'
            indicator={
              <div className="spin-center-content">
                <span className='ant-spin-dot ant-spin-dot-spin'>
                  <i className="ant-spin-dot-item"></i>
                  <i className="ant-spin-dot-item"></i>
                  <i className="ant-spin-dot-item"></i>
                  <i className="ant-spin-dot-item"></i>
                </span>
              </div>
            }
          >
            <CommonContent
              style={
                getParameterByName('deviceType') === 'iframe'
                  ? {
                      width: '100%',
                      marginTop: '60px',
                      padding: '0 24px',
                    }
                  : {
                      width: '100%',
                      padding: '0 24px',
                    }
              }
            >
              <ConversationWrapper>
                <LeftPart>
                  {showContactList && (
                    <ContactList
                      loading={loading}
                      handleChange={changeSessionOrMessage}
                      session={currentSession}
                      pathParms={pathParms}
                      selectFlag={selectFlag}
                      getUserList={getUserList}
                      handleChatType={(res) => {
                        setChatType(res);
                      }}
                      handleSetUid={(val) => {
                        if (!selectFlag) {
                          setUid('');
                        } else {
                          setUid(val);
                        }
                      }}
                      searchCondition={searchCondition}
                    />
                  )}
                  {/* {pageType === "search" && (
                  <SearchResult
                    handleChange={changeSessionOrMessage}
                    session={currentSession}
                    message={currentMessage}
                    searchCondition={searchCondition}
                    chatType={chatType}
                  />
                )} */}
                </LeftPart>
                <RightPart>
                  <ConversationTitle>
                    {currentSession.extendUserName && (
                      <HeadImg
                        url={currentSession.extendUserImg}
                        width={42}
                        height={42}
                        name={currentSession.extendUserName}
                      />
                    )}
                    {[2, 4].includes(currentSession?.sessionType) && (
                      <HeadImg
                        url={WxImg}
                        width={42}
                        height={42}
                        name={currentSession.extendUserName}
                      />
                    )}
                    {/*企微客户有头像，群有头像*/}
                    <InfoBar
                      style={{
                        marginLeft: (currentSession.extendUserName || [2, 4].includes(currentSession?.sessionType)) ? 16 : 0,
                      }}
                    >
                      <div className={'session-content'}>
                        <div className={'cv-name'}>
                          {currentSession.roomName ||
                            currentSession.extendUserName}
                          {currentSession.corpName && (
                            <span className={'cv-corpName'}>
                              @{currentSession.corpName}
                            </span>
                          )}
                        </div>
                        <Show
                          show={[2, 4].includes(
                            Number(currentSession?.sessionType)
                          )}
                        >
                          <div className='cv-roomOwnerName'>
                            群主：{currentSession.roomOwnerName}
                          </div>
                        </Show>
                        <UserLabels labels={currentSession.extendUserLabels} />
                      </div>
                      <IconWrapper
                        className={isClose ? '' : 'active'}
                        onClick={handleOpenInfo}
                      >
                        <ShowIcon src={isClose ? CloseIcon : OpenIcon} />
                      </IconWrapper>
                    </InfoBar>
                  </ConversationTitle>
                  <ConversationContent>
                    <ChatLog
                      log={chatLog}
                      session={currentSession}
                      reverse={false}
                      loadMore={(params) => {
                        setChatSearchCondition({
                          ...initCondition,
                          ...params,
                          pageNum: chatSearchCondition?.pageNum + 1,
                        });
                        setScrollType('top');
                      }}
                      height={140}
                      scrollType={scrollType}
                      message={currentMessage}
                      clearCurrentMessage={() => {
                        if (currentMessage?.mgsid) {
                          setCurrentMessage({ setType: 'message' });
                        }
                      }}
                      isEmpty={isEmpty}
                    />
                    {!isClose && (
                      <AllContent
                        session={currentSession}
                        handleClear={handleClear}
                        handleChange={changeSessionOrMessage}
                        uid={uid}
                        extendUserId={searchCondition.extendUserId}
                        isEmpty={isEmpty}
                        loading={loading}
                      />
                    )}
                  </ConversationContent>
                </RightPart>
              </ConversationWrapper>
              {/* <ConversationBottom /> */}
            </CommonContent>
          </Spin>{' '}
        </>
      ) : (
        <NoPermission />
      )}
    </MainContent>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(ConversationNew);
